import { ref } from 'vue';

/** 서버 세션 언어 동기화(selectUserInfo) 완료 후 증가 — 공통코드 재조회 트리거 */
const hrEvalCalculationLocaleRefreshTick = ref(0);

export const notifyHrEvalCalculationLocaleChanged = () => {
  hrEvalCalculationLocaleRefreshTick.value += 1;
};

export const useHrEvalCalculationLocaleRefreshTick = () => hrEvalCalculationLocaleRefreshTick;
